import {slider} from "layouts/_slider";

export function initializeProductSlider() {
  const items = document.querySelectorAll(".product-screens-item");
  const randomStartIdx = Math.floor(Math.random() * items.length);
  const changeInterval = 9000;
  slider.init(items, randomStartIdx, changeInterval);

  // Clear existing transition CSS
  document.querySelectorAll(".feature-image-container").forEach((item) => {
    const children = item.childNodes;
    children.forEach((item) => {
      if ((item as Element).classList) {
        (item as HTMLElement).style.transitionDelay = "0s";
      }
    });
  });
}

export function areProductScreensAvailable() {
  return document.querySelector(".productScreensSlideshow") !== null;
}
